module.exports = __webpack_public_path__ + "img/Account-Transaction-Grey.9e86b61b.svg";